import { type PathParams } from "@constellation-academy/epic-ui";
import { Card } from "primereact/card";
import { ProgressSpinner } from "primereact/progressspinner";
import { Suspense } from "react";
import { graphql, useLazyLoadQuery } from "react-relay";
import { useParams } from "react-router-dom";
import { useTranslation } from "@i18n/hooks";
import { type productEditScreen_ProductQuery } from "@relay/productEditScreen_ProductQuery.graphql";
import { LicenseProductForm } from "./parts/license-product-form/license-product-form.component";
import { NoAccess } from "../../components/no-access";
import { useHasPermissions } from "../../hooks/use-has-permissions";
import { type ProductsPath } from "../products";

const QUERY = graphql`
	query productEditScreen_ProductQuery($id: ID!, $skip: Boolean!) {
		node(id: $id) @skip(if: $skip) {
			... on Product {
				id
				data {
					kind
				}
				...licenseProductForm_LicenseProductFragment
			}
		}
		...licenseProductForm_QueryFragment
	}
`;
export const ProductEditScreen = () => {
	const { t } = useTranslation("common");
	const { productId } = useParams<PathParams<typeof ProductsPath>>();

	const query = useLazyLoadQuery<productEditScreen_ProductQuery>(QUERY, {
		id: productId!,
		skip: !productId,
	});

	const canReadAndModify = useHasPermissions([
		"UserInAccountPermission_ProductAdmin_Read",
		"UserInAccountPermission_ProductAdmin_Modify",
	]);

	const buildProductFormByProductType = () => {
		switch (query.node?.data?.kind) {
			case "License":
				return (
					<LicenseProductForm productFragmentRef={query.node} queryFragmentRef={query} />
				);
			default:
				return <></>;
		}
	};

	if (!canReadAndModify) return <NoAccess />;

	return query.node ? (
		<Suspense fallback={<ProgressSpinner />}>
			<div className="p-4">
				<Card>
					<h2 className="mb-3 text-center">[Produkt] {query.node?.id}</h2>
					{buildProductFormByProductType()}
				</Card>
			</div>
		</Suspense>
	) : (
		<h4>{t("product.loadError")}</h4>
	);
};
